import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, useLocation } from 'wouter';
import { actions } from '@/store/store';
import { useCart } from '@/providers/CartProvider';

const SalesProductPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [, navigate] = useLocation();

  useEffect(() => {
    dispatch(actions.salesProducts.loadOne({ id }));
  }, []);

  const salesProduct = useSelector(({ salesProducts }) => {
    return Object.values(salesProducts.records).find(
      (salesProduct) => salesProduct.id === id || salesProduct.identity === id
    );
  });

  const { addToCart, totalItems } = useCart();
  const [added, setAdded] = useState(false);

  const handleAddToCart = () => {
    addToCart(salesProduct);
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <div className="sales-product-page">
      <div className="breadcrumbs mb-4">
        <Link to="/">Shop</Link> &gt; {salesProduct?.sales_name}
      </div>

      <main className="row">
        <div className="col-md-6">
          <div className="product-image-wrapper">
            <img
              src={salesProduct?.sales_square}
              alt={salesProduct?.sales_name}
              className="product-image mb-4"
            />
          </div>
        </div>

        <div className="col-md-6">
          <div>
            <div className="mb-4">
              <h1 className="mb-4">{salesProduct?.sales_name}</h1>
              <p>${(salesProduct?.price_usd_cents/ 100).toFixed(2)}</p>
              <p>{salesProduct?.sales_description}</p>
            </div>

            <div className="mb-4">
              <button
                onClick={handleAddToCart}
                className="btn site-btn d-block w-100 mb-2"
              >
                {added ? (
                  <>
                    <span className="fa fa-check"></span>&nbsp;
                    Added to Cart!
                  </>
                ) : (
                  <>
                    <span className="fa fa-shopping-cart"></span>&nbsp;
                    Add to Cart
                  </>
                )}
              </button>

              <button
                onClick={() => navigate('/checkout')}
                className="btn site-btn btn-subtle btn-thin d-block w-100"
              >
                View Cart
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
};

export default SalesProductPage;